<template>
    <section>
        <div class="row">
            <div class="col-12">
                <fleet-list></fleet-list>
            </div>
        </div>
    </section>
</template>

<script>
import FleetList from '@/components/fleet/List';

export default {
    components: {
        FleetList
    }
}
</script>